import { inject } from "mobx-react";
import React from "react";
import { toast, ToastContainer, ToastPosition, TypeOptions } from "react-toastify";
import { MessageTypes, PostMessageEvent, WindowMessage } from "../lib/window-message";
import "./Notifications.style.scss";
import "react-toastify/dist/ReactToastify.css";

import type { Store } from "../../../client/stores/index";

export interface NotificationOptions {
    message: string;
    type?: TypeOptions;
    position?: ToastPosition;
}

interface NotificationsProps {
    options?: NotificationOptions;
    messages?: WindowMessage;
    store?: Store;
}

@inject("store")
export class Notifications extends React.Component<NotificationsProps> {
    toastId: React.ReactText = "";
    public constructor(props: NotificationsProps) {
        super(props);

        if (this.props.messages) {
            this.props.messages.events.subscribe(event => this.handleMessage(event as PostMessageEvent));
        }
    }

    private handleMessage = (event: PostMessageEvent) => {
        if (event && event.data && event.data.type) {
            switch (event.data.type) {
                case MessageTypes.OPEN:
                    this.notify(event.data.options);
                    break;
                case MessageTypes.CLOSE:
                    this.close();
                    break;
            }
        }
    };

    public notify = (options: NotificationOptions) => {
        if (!options.message) {
            return;
        }

        if (!this.toastId || !toast.isActive(this.toastId)) {
            this.toastId = toast(options.message, { type: options.type || "default" });

            window.postMessage(
                {
                    origin: window.location.href,
                    data: { type: MessageTypes.OPENED },
                },
                "*",
            );
        }

        this.props.store?.onAnalyticsAction?.dispatch({
            sectionName: "notifications",
            pageName: this.props.store.page.currentPage?.name || "",
            context: "notification_toast",
            action: "click",
        });
    };

    public close = () => {
        if (this.toastId && toast.isActive(this.toastId)) {
            toast.dismiss();
            window.postMessage(
                {
                    origin: window.location.href,
                    data: { type: MessageTypes.CLOSED },
                },
                "*",
            );
        }
    };

    public componentDidMount = () => {
        if (this.props.options) {
            this.toastId = toast(this.props.options.message, {
                type: this.props.options.type || "default",
                position: this.props.options.position || "bottom-center",
            });
        }
    };

    public render() {
        return <ToastContainer autoClose={8000} position="bottom-center" />;
    }
}

export default Notifications;
